<template>
  <GridContainer
    ref="wrapper"
    class="watch-configurator-wrapper"
  >
    <ScIntro
      class="watch-configurator-wrapper__intro"
      :class="{ 'watch-configurator-wrapper__intro--hide': hideIntro }"
      :content="INTRO"
      :hide-intro="hideIntro"
      :animate-on-viewport="animateIntro"
      @update:hideIntro="emitHideIntro"
    />
    <XiaomiWatchConfigurator v-if="hideIntro" />

    <Arrow
      v-if="hideIntro"
      class="watch-configurator-wrapper__back-cta"
      aria-label="Zurück"
      @change="clickedShowIntro"
    />
  </GridContainer>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import XiaomiWatchConfigurator from '@/components/xiaomi/xiaomi-watch-configurator.vue';
import ScIntro from '@/components/smartwatch-config/sc-intro.vue';
import { Arrow, GridContainer } from '@i22-td-smarthome/component-library';

const INTRO = {
  title: 'Dein Xiaomi Watch Konfigurator',
  productImages: [
    {
      src: `/content/content-images/landingpages/xiaomi/configurator/ab9ca069da02473b6ca5c9b4b45f4f68/intro-1.png`,

      alt: 'Xiaomi Watch 2 Pro',
    },
    {
      src: `/content/content-images/landingpages/xiaomi/configurator/d2038309b2a3c60ab83efc322f225af3/intro-2.png`,

      alt: 'Xiaomi Smart Band 8 Pro',
    },
    {
      src: `/content/content-images/landingpages/xiaomi/configurator/d536e8a46bf731a09f17075851c1c1fa/intro-3.png`,

      alt: 'Redmi Watch 4',
    },
    {
      src: `/content/content-images/landingpages/xiaomi/configurator/1e2a2345b0232662bae35e34db8f6d77/intro-4.png`,
      alt: 'Xiaomi Watch 3',
    },
  ],
  copy: 'Finde Deine passende Smartwatch in der perfekten Farbe.',
  cta: {
    label: 'Konfigurator starten',
  },
};

const hideIntro = ref(false);
const wrapper = ref();

function emitHideIntro(item: Boolean) {
  hideIntro.value = !item;
}
function clickedShowIntro() {
  hideIntro.value = false;
}

// is on viewport and play intro animation
const isOnViewport = ref();
function scrollIntoView() {
  const observer = new IntersectionObserver((entries) => {
    isOnViewport.value = entries[0].isIntersecting;
  });
  observer.observe(wrapper.value.$el);
}
const animateIntro = computed(() => !hideIntro.value && isOnViewport.value);
onMounted(() => {
  scrollIntoView();
});
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.watch-configurator-wrapper {
  position: relative;
  margin-bottom: $grid-base * 2;
  width: 100%;
  overflow-y: hidden;
  display: grid;

  > * {
    grid-column: 1;
    grid-row: 1;
  }

  &__intro {
    width: 100%;
    overflow: hidden;
    transition: margin-left cubic-bezier(0.47, 1.5, 0.41, 0.8) 650ms, opacity 650ms; // bounce effect
    &--hide {
      margin-left: -100%;
      opacity: 0;
    }
  }

  &__back-cta {
    left: 7px;
    font-size: 2em;

    @include mq($mq-md) {
      font-size: 3em;
      left: 2 * $grid-base;
    }
  }
}
</style>
